var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 3,
    fill: "#CD0B20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z",
    fill: "#CD0B20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4H21V11H0V4Z",
    fill: "#FFCB00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6.22201V8.742C9 9.442 8.328 10.002 7.5 10.002H5.5C4.674 10 4 9.43701 4 8.74001V6.22C4 5.648 4.448 5.17001 5.064 5.01501C5.25 4.49501 5.822 4.96101 6.5 4.96101C7.182 4.96101 7.75 4.498 7.936 5.016C8.55 5.175 9 5.65401 9 6.22201Z",
    fill: "#D4AF2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 7H10V10H9V7ZM3 7H4V10H3V7Z",
    fill: "#CBCBCB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9H10V10H9V9ZM3 9H4V10H3V9Z",
    fill: "#1A47B8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6H10V7H9V6ZM3 6H4V7H3V6Z",
    fill: "#D4AF2C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6H6V7.5H5V6ZM7 8H8V9.5H7V8Z",
    fill: "#AF010D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8H6V9.5H5V8Z",
    fill: "#FFCB00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6H8V7.5H7V6Z",
    fill: "#AE6A3E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6L5 5H8L7 6H6Z",
    fill: "#AF010D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4H7V5H6V4Z",
    fill: "#D4AF2C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 14,
    rx: 2.5,
    stroke: "black",
    strokeOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpain);
export default __webpack_public_path__ + "static/media/spain.bb2ebb3ef0ffac66a26065f5e0d35273.svg";
export { ForwardRef as ReactComponent };